<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="selectedUrl ? `${addurl}/${inputs.id}` : addurl"
      >
        <div class="row">
          <div class="col-md-12 form-group align-items-center">
            <h6 class="certificate-form-section">{{ $t("Basic information") }}</h6>
            <label for="inputs_title">
              {{ $t("title") }}
            </label>
            <app-input
              id="inputs_title"
              type="text"
              v-model="inputs.title"
              placeholder="Enter Title"
              :required="true"
            />
          </div>
        </div>
        <div class="row" v-if="showDescriptionEditor">
          <div class="col-md-12 form-group align-items-center">
            <label for="inputs_description">
              {{ $t("description") }}
            </label>
            <app-input
              id="inputs_description"
              type="text-editor"
              placeholder="Enter Description"
              v-model="inputs.description"
              :required="true"
            />
          </div>
        </div>
        <div class="row" v-if="type !== 'course_management'">
          <div class="col-md-12 form-group align-items-center">
            <label for="inputs_disclaimer">
              {{ $t("disclaimer") }}
            </label>
            <app-input
              id="inputs_disclaimer"
              type="textarea"
              placeholder="Enter Disclaimer"
              v-model="inputs.disclaimer"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 form-group align-items-center">
            <label for="inputs_type">
              {{ $t("select_type") }}
            </label>
            <app-input
              id="inputs_type"
              type="search-select"
              placeholder="Select Type"
              v-model="typeSelectedValue"
              :list='typeList'
              :required="true"
            />
          </div>
        </div>
        <div class="row" v-if="employee_certification_due_days">
          <div class="col-md-4 form-group align-items-center">
            <label for="inputs_expire_day">
              {{ $t("employee_certification_due_days") }}
            </label>
            <app-input
              id="inputs_employee_certification_due_days"
              type="number"
              placeholder="Enter Numbers of Due Days"
              v-model="inputs.employee_certification_due_days"
              :required="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 form-group align-items-center">
            <label for="inputs_category_name" >
              {{ $t("select_category") }}
            </label>
            <app-input
              id="inputs_category_name"
              type="search-select"
              placeholder="Select Category"
              v-model="inputs.category_id"
              :list='categorylist'
            />
            <p v-if="categoryAddShow == false" class="font-italic text-muted">
              {{ $t("shortcut_category_create") }} <span><a href="#" @click.prevent="addCategory()">{{$t("add_category")}}</a></span>
            </p>
            <div v-if="categoryAddShow == true" class="mt-2">
              <div class="d-flex align-items-center">
                <app-input
                  class="mr-2 flex-grow-1"
                  type="text"
                  placeholder="Enter Category Name"
                  v-model="category_name"/>
                <button type="submit"
                  class="btn btn-sm btn-primary mr-2"
                  @click.prevent="createCategory()">
                  {{ $t('save') }}
                </button>
                <a href="#" class="text-muted" @click.prevent="closeCategory()">
                    <app-icon name="x"/>
                </a>
              </div>
              <small class="text-danger ml-2" v-html="message"></small>
            </div>
          </div>
        </div>
        <div class="row" v-if="typeSelectedValue === 'employee_certification'">
          <div class="col-md-6 form-group align-items-center">
            <h6 class="certificate-form-section">{{ $t("Training settings") }}</h6>
            <label for="inputs_pricing_type">
              {{ $t("pricing_type") }}
            </label>
            <app-input
              id="inputs_pricing_type"
              type="select"
              v-model="inputs.pricing_type"
              :list="pricingTypeList"
              :required="true"
            />
          </div>
          <div class="col-md-6 form-group align-items-center" v-if="inputs.pricing_type === 'credit_based'">
            <label for="inputs_credit_usage">
              {{ $t("credit_usage_per_user") }}
            </label>
            <app-input
              id="inputs_credit_usage"
              type="number"
              placeholder="Enter Credits Required"
              v-model="inputs.credit_usage"
              :required="true"
            />
          </div>
        </div>
        <div class="row" v-if="typeSelectedValue === 'employee_certification'">
          <div class="col-md-6 form-group align-items-center">
            <label for="inputs_issuance_mode">
              {{ $t("certificate_issue_mode") }}
            </label>
            <app-input
              id="inputs_issuance_mode"
              type="select"
              v-model="inputs.issuance_mode"
              :list="issuanceModeList"
              :required="true"
            />
          </div>
        </div>
        <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-group">
            <label for="inputs_forms">{{ $t("forms") }}</label>
            <app-input
                type="multi-select"
                :isAnimatedDropdown="true"
                :placeholder="$t('forms')"
                :list="forms"
                v-model="inputs.forms"
                :required="true"
            />
            <p v-if="refreshShow === false" class="font-italic text-muted">
              {{ $t("shortcut_form_create") }} <span><a href="#" @click.prevent="createForm()">{{$t("create_new")}}</a></span>
            </p>
            <p v-if="refreshShow === true" class="font-italic text-muted">
              <a href="#" @click.prevent="refreshForm()">{{$t("refresh")}}</a><span> {{ $t("form_create_refresh") }}</span>
            </p>
          </div>
        </div>
          <div class="col-lg-6 col-md-6 col-sm-12 form-group align-items-center">
            <label for="inputs_expire_day">
              {{ $t("valid_until_days") }}
            </label>
            <app-input
              id="inputs_expire_day"
              type="number"
              placeholder="Enter Numbers of Days"
              v-model="inputs.expire_day"
              :required="true"
            />
          </div>
        </div>
        <div class="row" v-if="typeSelectedValue === 'employee_certification'">
          <div class="col-md-12 form-group align-items-center">
            <label for="inputs_course_duration">
              {{ $t("course_delivery_duration") }}
            </label>
            <app-input
              id="inputs_course_duration"
              type="text"
              placeholder="e.g. 24 hours, 2 days, 3 days"
              v-model="inputs.course_duration"
              :required="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-8 form-group align-items-center">
            <h6 class="certificate-form-section">{{ $t("Certificate signature") }}</h6>
            <label for="inputs_signature_type">
              {{ $t("signature_type") }}
            </label>
            <app-input
                type="radio"
                :list="signatureTypeList"
                v-model="inputs.signature_type"
                :required="true"
              />
          </div>
          <div class="col-md-4 form-group align-items-center" v-if="inputs.signature_type == 'picture_type'">
              <label>
                {{ $t("upload_signature_picture") }}
              </label>
              <app-input
                type="custom-file-upload"
                :label="$t('upload_your_file')"
                v-model="inputs.signature_file"
                :required="true"
              />
              <!-- <small class="text-muted font-italic">
                {{ $t("recommended_custom_file_validation") }}
              </small> -->
          </div>
          <!-- <div class="col-md-12 form-group align-items-center">
            <label for="inputs_expire_day">
              {{ $t("signature") }}
            </label>
            <VueSignaturePad
              id="signature"
              width="100%"
              height="200px"
              ref="signaturePad"
              :options="{onBegin: () => {$refs.signaturePad.resizeCanvas()}}"
            />
            <div class="mt-2 d-flex  justify-content-end align-items-center" >
              <button @click.prevent="undo" class="btn btn-danger mr-2" >Undo</button>
               <button @click.prevent="save" class="btn btn-success mr-5" >Save</button>
            </div>
          </div> -->
        </div>
        <div class="row">
          <div class="col-md-12 form-group align-items-center">
            <label for="inputs_signature_authority">
              {{ $t("Signature Authority") }}
            </label>
            <app-input
                id="inputs_signature_authority"
                type="textarea"
                placeholder="Signature Authority Name"
                v-model="inputs.signature_authority"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 form-group align-items-center">
            <label for="inputs_authority_name">
              {{ $t("Authority Name") }}
            </label>
            <app-input
                id="inputs_authority_name"
                type="text"
                placeholder="Authority Name"
                v-model="inputs.authority_name"
                :required="true"

            />
          </div>
        </div>
        <div class="row" v-if="showSignature">
          <div class="col-md-12 form-group align-items-center">
            <label for="inputs_signature">
              {{ $t("last_signature") }}
            </label>
            <img class="mr-4" :src="signaturePath" alt="LOGO" height="auto" width="50%" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 form-group">
              <label>
                {{ $t("upload_training_profile_picture") }}
              </label>
              <app-input
                type="custom-file-upload"
                :label="$t('upload_your_file')"
                v-model="inputs.file"
                :required="true"
              />
              <!-- <small class="text-muted font-italic">
                {{ $t("recommended_custom_file_validation") }}
              </small> -->
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12">
            <div id="accordion">
              <div class="card">
                <div class="card-header" id="heading-1">
                  <h5 class="mb-0">
                    <a role="button" class="heading-style" data-toggle="collapse" href="#collapse-1" aria-expanded="true" aria-controls="collapse-1">
                      Certificate Theme</a>
                  </h5>
                </div>
                <div id="collapse-1" class="collapse show" data-parent="#accordion" aria-labelledby="heading-1">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-4 p-2">
                        <label for="layout1" class="mb-0">{{ $t("layout1") }}</label>
                        <input id="layout1" class="form-control color-style" type="color" v-model="theme.layout1"/>
                      </div>

                      <div class="col-4 p-2">
                        <label for="layout2" class="mb-0">{{ $t("layout2") }}</label>
                        <input id="layout2" class="form-control color-style" type="color" v-model="theme.layout2"/>
                      </div>

                      <div class="col-4">
                        <label for="layout3" class="mb-0">{{ $t("layout3") }}</label>
                        <input id="layout3" class="form-control color-style" type="color" v-model="theme.layout3"/>
                      </div>  
                      <div class="col-4">
                        <label for="main_body" class="mb-0">{{ $t("main_body_color") }}</label>
                        <input id="main_body" class="form-control color-style" type="color" v-model="theme.main_body"/>
                      </div>
                      <div class="col-4">
                        <label for="font_color" class="mb-0">{{ $t("font_color") }}</label>
                        <input id="font_color" class="form-control color-style" type="color" v-model="theme.font_color"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import * as actions from "../../../../Config/ApiUrl";
// import {CERTIFICATE_CATEGORY_GET} from "../../../../../app/Config/ApiUrl";
import { axiosGet, axiosPost} from "../../../../../app/Helpers/AxiosHelper";
import {BUYER_CERTIFICATE_FORMS} from "../../../../Config/ApiUrl";

export default {
  name: "AddUpdateCertificateModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    type: String,
  },
  data() {
    return {
      refreshShow: false,
      typeSelectedValue: '',
      employee_certification_due_days: false,
      showSignature: false,
      showDescriptionEditor: false,
      signaturePath: '',
      cat: {},
      forms: [],
      message: '',
      categoryAddShow: false,
      category_name: '',
      addurl:actions.CERTIFICATE_STORE,
      preloader: false,
      inputs: {
        pricing_type: 'free',
        credit_usage: 0,
        issuance_mode: 'manual',
      },
      categorylist: [],
      pricingTypeList: [
        { id: "free", value: "Free" },
        { id: "credit_based", value: "Credits Based" },
      ],
      issuanceModeList: [
        { id: "manual", value: "Manual Certificate Issue" },
        { id: "automatic", value: "Automatic Certificate Issue" },
      ],
      theme: {
        layout1: '#1a2153',
        layout2: '#ffd700',
        layout3: '#949494',
        main_body: '#ffffff',
        font_color: '#1a2153',
      },
      modalId: "certificate-add-edit-Modal",
      modalTitle: this.$t("add"),
      signatureTypeList: [
        { id: "font_type", value: "Font Type" },
        { id: "picture_type", value: "Picture Type" },
      ],
      typeList: [
        {
          id: 'membership',
          value: 'Membership'
        },
        {
          id: 'certified_membership',
          value: 'Certified Membership'
        },
        {
          id: 'compliance',
          value: 'Compliance'
        },
        {
          id: 'employee_certification',
          value: 'Employee Certification'
        },
      ]
    }
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      // this.postUrl = actions.CERTIFICATE_UPDATE;
      // this.preloader = true;
    }
    else {
      this.showDescriptionEditor = true;
    }
  },
  methods: {
    createForm() {
      this.refreshShow = true;
      window.open(this.typeSelectedValue === 'employee_certification' ? '/admin/documentlibrary/mytraining' : '/admin/documentlibrary/mydocument', '_blank');
    },
    formName(formId){
      let formObj = {};
      for (let i = 0; i < this.forms.length; i++) {
        if (this.forms[i].id === formId) {
          formObj = this.forms[i];
        }
      }
      if(formObj){
        return formObj.value;
      }
    },
    getForms() {
      axiosGet(BUYER_CERTIFICATE_FORMS)
          .then((res) => {
            this.forms = res.data;
            // this.total_recuring_task = res.data.total_recuring_task;
          })
          .catch((error) => {

          });
    },
    refreshForm() {
      this.refreshShow = false;
      this.getForms();

    },
    addCategory() {
      this.categoryAddShow = true;
    },
    closeCategory() {
      this.categoryAddShow = false;
    },
    createCategory() {
      if (this.category_name == '') {
          this.message = 'Category name is required';
      }
      else {
        this.cat.category_name = this.category_name;
        axiosPost(actions.CERTIFICATE_CATEGORY_STORE, this.cat)
          .then((res) => {
            this.categoryAddShow = false;
            this.$toastr.s(res.data.message);
            this.getCategories();
            this.category_name = '';
          })
          .catch((error) => {
            
          });
      }
    },
    submit() {
      this.fieldStatus = {};
      this.fieldStatus.isSubmit = true;

      if (!this.isValidForm()) {
        return;
      }

      this.inputs.theme = JSON.stringify(this.theme);
      this.inputs.type = this.typeSelectedValue;
      if (this.inputs.pricing_type !== 'credit_based') {
        this.inputs.credit_usage = 0;
      }
      // const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      // if(data != null) {
      //   this.inputs.signature = data;
      // }
      // else {
      //   this.inputs.signature = this.signaturePath;
      // }

      let formData = new FormData();
        Object.keys(this.inputs).forEach((key) => {
          formData.append(key, this.inputs[key]);
        });
      if (this.modalTitle === "Edit") {
        this.preloader = true;
        axiosPost(actions.CERTIFICATE_UPDATE, formData)
          .then((res) => {
            
            this.$toastr.s(res.data.message);
          })
          .catch((error) => {
            
            this.$toastr.e(error);
          })
          .finally(() => {
            this.preloader = false;
            $("#certificate-add-edit-Modal").modal("hide");
            this.$hub.$emit("reload-" + this.tableId);
          });
      } else {
          this.save(formData);
      }
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      // if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.inputs.pricing_type = response.data.pricing_type || 'free';
      this.inputs.credit_usage = response.data.credit_usage || 0;
      this.inputs.issuance_mode = response.data.issuance_mode || 'manual';
      if (response.data.signature != null) {
          this.signaturePath = response.data.signature;
          this.showSignature = true;
      }
      this.inputs.file = response.data.logo;
      this.showDescriptionEditor = true;
      if(response.data.theme) {
        this.theme = JSON.parse(response.data.theme);
      }
      this.preloader = false;
    },

    getCategories() {
      axiosGet(actions.CERTIFICATE_CATEGORY_GET)
        .then((res) => {
          this.categorylist = res.data;
        })
        .catch((error) => { 
          
        });
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    getTypeSelectedValue() {
      this.employee_certification_due_days = this.typeSelectedValue == 'employee_certification' ? true : false;
      if (this.typeSelectedValue !== 'employee_certification') {
        this.inputs.pricing_type = 'free';
        this.inputs.credit_usage = 0;
        this.inputs.issuance_mode = 'manual';
      } else if (!this.inputs.pricing_type) {
        this.inputs.pricing_type = 'free';
      } else if (!this.inputs.issuance_mode) {
        this.inputs.issuance_mode = 'manual';
      }

    }
  },

  mounted() {
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
    this.getCategories();
    this.getForms();
    if(this.type === 'course_management'){
      this.typeSelectedValue = 'employee_certification'
      this.inputs.pricing_type = 'free'
      this.inputs.issuance_mode = 'manual'
    }

  },
  watch: {
    typeSelectedValue() {
      this.getTypeSelectedValue();
    }
  }
};
</script>
<style scoped>
.certificate-form-section {
  width: 100%;
  margin: 0 0 1rem;
  padding-bottom: .5rem;
  border-bottom: 1px solid #e5e7eb;
  color: #3f4254;
  font-weight: 600;
}
</style>
